export default __webpack_public_path__ + "static/media/TutorialsTonic.f0262794e724b338e3e8d6cec7ffeb81.webp";